export default __webpack_public_path__ + "static/media/India.aab9409e.svg";